module.exports = __webpack_public_path__ + "img/loan.fdc05f22.svg";